import { objectKeys } from '@motimate/utils';
import { languages } from '@ui/utils/language';

export const locales = objectKeys(languages);

export type Locale = (typeof locales)[number];

export const defaultLocale: Locale = 'en';
